import { useConfigStore } from '@/stores/configStore';
import useTickSound from './useTickSound';

/**
 * Custom hook for handling TTS interactions with tick sound fallback
 * Provides handlers for click and keyboard events with TTS or tick sound
 */
export const useTickSoundInteraction = () => {
    const voice = useConfigStore((state) => state.config.tts.voice);
    const { playTick } = useTickSound();

    /**
     * Wrapper for click handlers that plays tick sound when voice is disabled
     */
    const handleInteraction = (e: any, callback: () => void) => {
        const playsound = e?.currentTarget?.getAttribute('data-playsound') || 'tick';
        playTick(playsound);
        callback();
    };

    /**
     * Wrapper for keyboard event handlers that plays tick sound when voice is disabled
     */
    const handleKeyboardInteraction = (e: React.KeyboardEvent, callback: () => void) => {
        if (e.key === 'Enter') {
            const playsound = e.currentTarget.getAttribute('data-playsound') || 'tick';
            playTick(playsound);
            callback();
        }
    };

    const handleKeyUpInteraction = (e: React.KeyboardEvent, callback?: () => void) => {
        if (e.key !== 'Enter') {
            playTick();
            callback?.();
        }
    };

    return {
        handleInteraction,
        handleKeyboardInteraction,
        handleKeyUpInteraction,
        voice,
        playTick,
    };
};
